// Adds one or more formulas in one request (the Duo, a stack, the quiz match) and opens the cart drawer.
// A line may carry items[i][selling_plan] (a stack on Subscribe & Save); it is passed through.
// Without JS (or on a failed request) the form posts to /cart/add as usual.
(function () {
  if (window.nAddItemsBound) return;
  window.nAddItemsBound = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-n-add-items]');
    if (!form || !window.fetch) return;
    const cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function') return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-n-add-error]');
    const data = new FormData(form);
    const items = [];
    for (let i = 0; data.has(`items[${i}][id]`); i += 1) {
      const item = { id: Number(data.get(`items[${i}][id]`)), quantity: Number(data.get(`items[${i}][quantity]`) || 1) };
      const plan = data.get(`items[${i}][selling_plan]`);
      if (plan) item.selling_plan = Number(plan);
      items.push(item);
    }
    const sections = cart.getSectionsToRender().map((section) => section.id);
    if (button) button.setAttribute('aria-busy', 'true');

    fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) {
          if (error) {
            error.textContent = state.description || state.message || window.cartStrings.error;
            error.hidden = false;
          }
          return;
        }
        if (error) error.hidden = true;
        // As Dawn's product form does: a drawer rendered on an empty cart keeps .is-empty,
        // which hides the new lines until a reload.
        cart.classList.remove('is-empty');
        cart.renderContents({ id: items[0].id, sections: state.sections });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'n-add-items', productVariantId: items[0].id, cartData: state });
        }
      })
      .catch(() => form.submit())
      .finally(() => {
        if (button) button.removeAttribute('aria-busy');
      });
  });
})();
